// 受講生一覧ページ
export const ManualText01 = `
<strong>概要</strong>
<ul class="manual_list">
  <li>ユーザー管理画面になります。主にユーザーの削除・検索を行います</li>
</ul>
<strong>ヘッダーメニュー</strong>
<ul class="manual_list">
  <li>Users...受講生一覧ページへ</li>
  <li>Videos...動画一覧ページへ</li>
  <li>Audios...音声一覧ページへ</li>
  <li>Register...ユーザー新規作成ページへ</li>
</ul>
`

// 動画一覧
export const ManualText02 = `
<strong>概要</strong>
<ul class="manual_list">
  <li>受講生が動画を視聴するページ</li>
  <li>「カテゴリー選択」から、カテゴリ別に表示の切り替えが可能</li>
</ul>
`

// 音声一覧
export const ManualText03 = `
<strong>概要</strong>
<ul class="manual_list">
  <li>受講生が音声を拝聴・ダウンロードするページ</li>
  <li>「カテゴリー選択」から、カテゴリ別に表示の切り替えが可能</li>
  <li>タイトルをクリックすることで再生されます</li>
  <li>ダウンロードボタンは一括ダウンロードと個別でダウンロードの2種類用意してあります</li>
  <li><strong>「全部ダウンロードする」ボタンは、そのページに表示されている音声ファイルが一括でダウンロードされます</strong><br />（例）Original-Bの音声ファイルを一括でDLしたい<br />「カテゴリー選択」でOriginal-Bを選択→「全部ダウンロードする」を押す</li>
</ul>
`

// ユーザー新規登録
export const ManualText04 = `
<strong>概要</strong>
<ul class="manual_list">
  <li>ユーザーを新規登録するページ</li>
  <li>各項目入力後に「Register」を押下することでユーザー登録の完了となります</li>
  <li>パスワードは「自動生成」ボタンで生成可能（任意でも登録可能）</li>
  <li>「目」のアイコンをクリックで、パスワードの表示・非表示が可能</li>
  <li><strong>「Register」を押す前に必ず登録パスワードのメモをお願いします</strong></li>
</ul>
`

// モバイル端末での音声ダウンロードについて
export const ManualText05 = `
<p><strong>※使用するモバイル端末やブラウザによって差異がありますのでご確認お願いします。</strong></p>
<strong>iPhoneの場合</strong>
<ul class="manual_list">
  <li>iPhoneで音声ファイルをダウンロードするには<strong>iOS13.1.2以上のバージョン</strong>が必要となります</li>
  <li>iPhoneでお使いのブラウザが<strong>Google Chrome</strong>の場合、仕様上、音声ファイルのダウンロードができません。<strong>Safari</strong>をご使用ください</li>
  <li>iPhoneよりダウンロードされた音声は「ファイル」Appに保存されます</li>
  <li>「ミュージック」Appで再生したい場合、PCからiTunesを経由して同期する必要があります</li>
</ul>
<strong>Androidの場合</strong>
<ul class="manual_list">
  <li>Android端末からGoogle Chromeでのダウンロードは可能（Android 7.0 検証済み）</li>
</ul>
<strong>まとめ</strong>
<ul class="manual_list">
  <li>iPhoneでダウンロードするには<strong>iOS13.1.2以上のバージョン</strong>が必須</li>
  <li>iPhoneでGoogle Chromeから<strong>mp3ファイルのダウンロードは仕様上不可能</strong></li>
  <li>Androidの場合、<strong>Google Chromeからダウンロードができる</strong></li>
</ul>
`